import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { setSelectedDate } from '@store/global/slice';
import { setSearchSingleOrderUnvId, setGobackReportingsUrl } from '@pages/orders/store/slice';



interface OrderClickParams {
	date: string,
	orderUnvId: string,
}


const useOrderClick = (params: OrderClickParams) => {
	const { date, orderUnvId } = params;
	
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const updateSearchSingleOrderUnvId = (value: string) => dispatch(setSearchSingleOrderUnvId(value));
	const updateGobackReportingsUrl = (url: string) => dispatch(setGobackReportingsUrl(url));
	const updateSelectedDate = (date: string) => dispatch(setSelectedDate(date));

	
	const clickToOrder = useCallback(() => {
		if (date && orderUnvId) {
			updateSearchSingleOrderUnvId(orderUnvId);
			updateGobackReportingsUrl(location.pathname + location.search);
			updateSelectedDate(date);
			navigate(NavigateRoutesEnum.search);
		}
	},[ date, orderUnvId ]);

	
	return clickToOrder;
};

export default useOrderClick;